<template>
  <div class="total-item">
    <span class="label">活動折抵：</span>
    <span class="price">-{{ cartDiscount | dollar }}</span>
  </div>
</template>

<script>
import { dollar } from '@/helpers/format/dollar';
import { getState } from '@/helpers/vuex';

export default {
  name: 'activity-discount',
  filters: {
    dollar,
  },
  computed: {
    /** 活動折抵 */
    cartDiscount: getState('AmountDetail', 'cartDiscount'),
  },
};
</script>
